/**
 * @deprecated use version from `@academysports/util-lib` instead
 */
export const canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * @deprecated use version from `@academysports/util-lib` instead
 */
export const canUseWorkers = typeof Worker !== 'undefined';

/**
 * @deprecated use version from `@academysports/util-lib` instead
 */
export const canUseEventListeners = canUseDOM && !!(window.addEventListener || window.attachEvent);

/**
 * @deprecated use version from `@academysports/util-lib` instead
 */
export const canUseViewport = canUseDOM && !!window.screen;

/**
 * @deprecated use version from `@academysports/util-lib` instead
 */
export const isInWorker = !canUseDOM;

/**
 * @deprecated use version from `@academysports/util-lib` instead
 */
export const isTestEnv = () => navigator.userAgent.includes('jsdom');
